<template>
  <div class="candidate-panel" data-step="14">
    <i class="close bi bi-x-lg" @click="$emit('close')" />
    <h2>
      Résultats de {{ currentParticipant?.candidate?.first_name }}
      {{ currentParticipant?.candidate?.last_name }}
    </h2>
    <ProgressCircular
      :value="
        currentParticipant.results
          ? currentParticipant.results.compatibility
          : 0
      "
    />
    <h4>Compatibilité du talent</h4>
    <p>
      Cette valeur est calculée sur la base de la pondération que vous avez
      configurée.
    </p>
    <Button
      v-if="state.windowWidth > 1024 && campaignVersion?.duration !== 25"
      class="primary sm icon icon-left download-btn"
      label="Exporter en PDF et accéder à plus de données"
      icon="bi-download"
      @click="emits('preview')"
    />
    <TabsNavigation
      :tabs="tabLabels"
      @changeTab="(value) => (state.currentTab = value)"
    />
    <Transition name="fade" mode="out-in">
      <Component
        :is="tabComponents[state.currentTab]"
        :currentCandidate="currentParticipant"
      />
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { reactive, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useCampaignStore } from "@/stores/campaign.js";
import { useOnboardingStore } from "@/stores/onboarding.js";
import General from "./tabs/General.vue";
import Skills from "./tabs/Skills.vue";
import Personnality from "./tabs/Personnality.vue";
import Informations from "./tabs/Informations.vue";
import Notes from "./tabs/Notes.vue";
import ProgressCircular from "@/components/global/ProgressCircular.vue";

const emits = defineEmits(["close", "preview"]);

const route = useRoute();

const campaignStore =
  route.name === "campaign" ? useCampaignStore() : useOnboardingStore();

defineProps({
  currentParticipant: {
    type: Object,
  },
});

const state = reactive({
  currentTab: 0,
  windowWidth: 0,
});

const tabComponents = computed(() => {
  if (campaignStore.currentCampaign.version === 1) {
    return [General, Skills, Informations, Notes];
  }

  return [General, Skills, Personnality, Informations, Notes];
});

const tabLabels = computed(() => {
  const labels = ["Récapitulatif", "Compétences"];

  if (campaignStore.currentCampaign.version === 2) {
    labels.push("Personnalité");
  }

  labels.push("Informations", "Notes");

  return labels;
});

const campaignCalibrationID = computed(() => {
  if (!campaignStore.currentCampaign) return null;

  return campaignStore.currentCampaign.calibration_id;
});

const campaignVersion = computed<CampaignVersion | null>(() => {
  return getVersionObjectFromVersionID(campaignCalibrationID.value);
});

onMounted(() => {
  state.windowWidth = window.innerWidth;
});
</script>
